import React, { useEffect } from "react";
import ChatListShimmer from "./ChatListShimmer";
import { FiX } from "react-icons/fi";

const NewChatPopup = ({ setNewChatPopup, people, setActiveChat, error, onRetry }) => {
  useEffect(() => {
    const close = event => { if (event.key === "Escape") setNewChatPopup(false); };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [setNewChatPopup]);
  return (
    <div
      onClick={() => setNewChatPopup(false)}
      className="fixed inset-0 bg-black/80 flex justify-center items-center z-50"
    >
      <div
        role="dialog" aria-modal="true" aria-labelledby="new-conversation-title"
        onClick={(e) => e.stopPropagation()}
        className="w-[90dvw] md:w-[50dvw] h-[80dvh] bg-white rounded-lg p-6 overflow-auto"
      >
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <div className="flex items-center justify-between gap-3"><h2 id="new-conversation-title" className="text-lg leading-none font-semibold">New conversation</h2>
            <button type="button" aria-label="Close new conversation" title="Close" onClick={() => setNewChatPopup(false)} className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-gray-100"><FiX /></button></div>
          <p className="text-gray-500 text-sm">
            Select a team member to start a conversation.
          </p>
        </div>
        {error ? <p role="alert" className="mt-4 text-sm text-red-700">{error}<button type="button" onClick={onRetry} className="ml-2 underline">Try again</button></p> : !people ? (
          <ChatListShimmer />
        ) : (
          <div className="py-4">
            {!people.length && <p className="text-sm text-gray-600">No members available.</p>}
            <div className="space-y-1 max-h-[400px] overflow-y-auto">
              {people.map((person) => (
                <div key={person._id}>
                  <button type="button"
                    onClick={() => {
                      setActiveChat({
                        _id: person._id,
                        username: person.username,
                        email: person.email,
                        type: "direct",
                        participantIds: person._id,
                      });
                      setNewChatPopup(false);
                    }}
                    className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <div>{person.username}</div>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewChatPopup;
